<h2>Quarter Master</h2>

<div class="px-2 py-3 contents h-full max-h-80" *ngIf="isLoadQuarterMasterGridDataSource">
    <div class="flex pb-4 justify-start">
        <dx-check-box [value]="false" text="Include deactivated Quarter Master Mapping items" class="pr-2" (onValueChanged)="extraFilteringOptionsChange('Active', $event)"></dx-check-box>
    </div>
    <div class="mapping-grid-container shadow-lg">
        <div class="flex">
            <button type="button" class="btn btn-light btn-create-product" (click)="addQuarterMaster()"><i class="fa fa-plus" aria-hidden="true"></i></button>
        </div>
        <dx-data-grid
            #quarterMasterMappingDataGrid
            id="quarterMasterMappingDataGrid"
            [allowColumnResizing]="true"
            [columnResizingMode]="'widget'"
            [allowColumnReordering]="true"
            [dataSource]="quarterMasterMappingDataSource"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [remoteOperations]="true"
            [hoverStateEnabled]="true"
            [(selectedRowKeys)]="quarterMasterMappingSelectedRowMap"
            (onSelectionChanged)="selectionMappingDataChangedHandler()"
            (onContentReady)="onReady($event)"
            (onContextMenuPreparing)="quarterMasterMappingDataGridContextMenu($event)"
            (onRowUpdating)="saveEdit($event)"
            (onRowUpdated)="rowUpdated()"
            keyExpr="QuarterId"
        >
            <dxo-state-storing
                    [enabled]="true"
                    type="custom"
                    [customLoad]="loadMasterState"
                    [customSave]="saveMasterState">
            </dxo-state-storing>
            <dxo-editing
                    mode="row"
                    [allowUpdating]="true"
                    [allowDeleting]="false"
                    [allowAdding]="false"
            >
            </dxo-editing>
            <dxo-load-panel
                    [enabled]="false"
                    shadingColor="rgba(0,0,0,0.4)"
                    [showIndicator]="true"
                    [showPane]="true"
                    [shading]="true">
            </dxo-load-panel>
            <dxo-filter-panel [visible]="true"></dxo-filter-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-pager
                    [visible]="true"
                    [allowedPageSizes]="[5, 10, 25, 50, 100]"
                    displayMode="compact"
                    [showPageSizeSelector]="true"
                    [showNavigationButtons]="false"
            >
            </dxo-pager>
            <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
            <dxo-selection mode="single"></dxo-selection>
            <dxo-column-chooser [enabled]="true" mode="dragAndDrop"></dxo-column-chooser>
            <dxi-column dataField="QuarterId" [allowHeaderFiltering]="false" [width]="140" caption="Quarter Id" [customizeText]="customizeQuarterMasterId" [allowEditing]="false"></dxi-column>
            <dxi-column caption="Action" cellTemplate="action" alignment="center" [allowHeaderFiltering]="false" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="Year" [allowEditing]="false">
                <dxo-header-filter [dataSource]="yearHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="Quarter" [allowEditing]="false">
                <dxo-header-filter [dataSource]="quarterHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="TimePeriodKey" [allowEditing]="false">
                <dxo-header-filter [dataSource]="timePeriodKeyHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="IsMapping" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column dataField="IsReleased" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column dataField="IsCovidPassThrough" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column caption="Data auditing">
                <dxi-column dataField="CreatedByUserFullNameSortableOrPrincipalName" caption="Created by" [visible]="false" [allowEditing]="false">
                    <dxo-header-filter [dataSource]="createdByHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CreatedOn" caption="Create on" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon" [allowEditing]="false">
                    <dxo-header-filter [dataSource]="createdOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedByUserFullNameSortableOrPrincipalName" caption="Modified by" >
                    <dxo-header-filter [dataSource]="modifiedByHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedOn" caption="Modified on" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon" [allowEditing]="false">
                    <dxo-header-filter [dataSource]="modifiedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedByUserFullNameSortableOrPrincipalName" caption="Reviewed by" [visible]="false" [allowEditing]="false">
                    <dxo-header-filter [dataSource]="reviewedByHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedOn" caption="Reviewed on" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon" [allowEditing]="false">
                    <dxo-header-filter [dataSource]="reviewedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>
            <dxi-column dataField="Active" [allowEditing]="false"></dxi-column>
            <div *dxTemplate="let action of 'action'">
                <dx-button *ngIf="currentUser?.UserRoleId > 1 && action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Deactivate" (onClick)="deactivate(action?.data?.CountryMappingId)"></dx-button>
                <dx-button *ngIf="currentUser?.UserRoleId > 1 && !action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Reactivate" (onClick)="reactivate(action?.data?.CountryMappingId)"></dx-button>
            </div>
            <dxo-paging [pageSize]="5"></dxo-paging>
        </dx-data-grid>
    </div>
</div>
